import { ResourceCard } from '../types';
import { videoLinks, videoLinksStatic } from '../constants';
import { generateResourceCard } from '../utils/resource-card.util';

export const VIDEOS_MOCK_DATA: ResourceCard[] = generateResourceCard(
  videoLinks,
  { ...videoLinksStatic(true, 'resource-videos__') },
);
